(function () {
  if (window.ScudoCartValidation) return;

  window.ScudoCartValidation = (function () {
    const contexts = {};
    let booted = false;

    let validateTimer = null;
    let settleTimer = null;
    let settleInterval = null;

    let lastState = {
      valid: true,
      error: '',
      gpsDeviceQty: 0,
      gpsSimQty: 0,
      damiduDeviceQty: 0,
      damiduPlanQty: 0
    };

    function getLang() {
      const lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      return lang.startsWith('it') ? 'it' : 'en';
    }

    function t(key) {
      const messages = {
        it: {
          sim_without_gps: 'La SIM può essere acquistata solo insieme a un dispositivo GPS.',
          sim_exceeds_gps: 'Il numero di SIM non può superare il numero di dispositivi GPS.',
          damidu_missing_plan: 'Ogni dispositivo Damidu richiede un piano attivo.',
          damidu_plan_without_device: 'Non puoi acquistare un piano Damidu senza un dispositivo Damidu associato.'
        },
        en: {
          sim_without_gps: 'The SIM can only be purchased together with a GPS device.',
          sim_exceeds_gps: 'The number of SIM cards cannot exceed the number of GPS devices.',
          damidu_missing_plan: 'Each Damidu device requires an active subscription.',
          damidu_plan_without_device: 'You cannot purchase a Damidu subscription without an associated Damidu device.'
        }
      };

      const lang = getLang();
      return (messages[lang] && messages[lang][key]) || messages.en[key] || '';
    }

    function normalize(value) {
      return String(value || '').trim().toLowerCase();
    }

    function getProperty(item, keyName) {
      const props = item && item.properties ? item.properties : {};
      for (const key in props) {
        if (normalize(key) === normalize(keyName)) {
          return String(props[key] || '').trim();
        }
      }
      return '';
    }

    function getItemRole(item) {
      const explicitRole = normalize(getProperty(item, '_scudo_role'));

      if (
        explicitRole === 'gps_device' ||
        explicitRole === 'gps_sim' ||
        explicitRole === 'damidu_device' ||
        explicitRole === 'damidu_plan'
      ) {
        return explicitRole;
      }

      const title = normalize(item.product_title || item.title);
      const productType = normalize(item.product_type);
      const handle = normalize(item.handle);

      if (
        productType.includes('sim') ||
        title.includes('sim card') ||
        title.includes('iot sim') ||
        handle.includes('sim')
      ) {
        return 'gps_sim';
      }

      if (
        productType.includes('subscription') ||
        productType.includes('plan') ||
        title.includes('basic plan') ||
        title.includes('advanced plan') ||
        title.includes('subscription')
      ) {
        return 'damidu_plan';
      }

      if (title.includes('damidu')) {
        return 'damidu_device';
      }

      if (
        productType.includes('tracker') ||
        productType.includes('gps') ||
        productType.includes('heavy duty') ||
        productType.includes('telematics')
      ) {
        return 'gps_device';
      }

      return '';
    }

    function validateScudoCart(cart) {
      let gpsDeviceQty = 0;
      let gpsSimQty = 0;
      let damiduDeviceQty = 0;
      let damiduPlanQty = 0;

      (cart.items || []).forEach(function (item) {
        const qty = Number(item.quantity || 0);
        const role = getItemRole(item);

        if (role === 'gps_device') gpsDeviceQty += qty;
        if (role === 'gps_sim') gpsSimQty += qty;
        if (role === 'damidu_device') damiduDeviceQty += qty;
        if (role === 'damidu_plan') damiduPlanQty += qty;
      });

      let error = '';

      if (gpsSimQty > 0 && gpsDeviceQty === 0) {
        error = t('sim_without_gps');
      } else if (gpsSimQty > gpsDeviceQty) {
        error = t('sim_exceeds_gps');
      } else if (damiduDeviceQty > 0 && damiduPlanQty < damiduDeviceQty) {
        error = t('damidu_missing_plan');
      } else if (damiduPlanQty > 0 && damiduDeviceQty === 0) {
        error = t('damidu_plan_without_device');
      }

      return {
        valid: !error,
        error: error,
        gpsDeviceQty: gpsDeviceQty,
        gpsSimQty: gpsSimQty,
        damiduDeviceQty: damiduDeviceQty,
        damiduPlanQty: damiduPlanQty
      };
    }

    function statesEqual(a, b) {
      return !!a && !!b &&
        a.valid === b.valid &&
        a.error === b.error &&
        a.gpsDeviceQty === b.gpsDeviceQty &&
        a.gpsSimQty === b.gpsSimQty &&
        a.damiduDeviceQty === b.damiduDeviceQty &&
        a.damiduPlanQty === b.damiduPlanQty;
    }

    function setMessage(el, error) {
      if (!el) return;
      el.textContent = error || '';
      el.hidden = !error;
    }

    function disableElement(el) {
      if (!el) return;
      el.disabled = true;
      el.setAttribute('disabled', 'disabled');
      el.setAttribute('aria-disabled', 'true');
      el.classList.add('is-disabled');
      el.style.pointerEvents = 'none';
      el.style.opacity = '0.5';
    }

    function enableElement(el) {
      if (!el) return;
      el.disabled = false;
      el.removeAttribute('disabled');
      el.removeAttribute('aria-disabled');
      el.classList.remove('is-disabled');
      el.style.pointerEvents = '';
      el.style.opacity = '';
    }

    function setDynamicButtons(root, selector, isValid) {
      if (!root || !selector) return;

      root.querySelectorAll(selector).forEach(function (el) {
        if (isValid) {
          el.hidden = false;
          el.style.display = '';
          el.style.pointerEvents = '';
          el.style.opacity = '';
          el.removeAttribute('aria-hidden');
        } else {
          el.hidden = true;
          el.style.display = 'none';
          el.style.pointerEvents = 'none';
          el.style.opacity = '0.5';
          el.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function applyStateToContext(context, state) {
      const root = document.querySelector(context.rootSelector);
      if (!root) return;

      const messageEl = root.querySelector(context.messageSelector);
      const checkoutBtn = root.querySelector(context.checkoutSelector);

      setMessage(messageEl, state.error);

      if (state.valid) {
        enableElement(checkoutBtn);
        root.removeAttribute('data-scudo-invalid');
      } else {
        disableElement(checkoutBtn);
        root.setAttribute('data-scudo-invalid', 'true');
      }

      setDynamicButtons(root, context.dynamicCheckoutSelector, state.valid);
    }

    function applyStateEverywhere(state) {
      Object.keys(contexts).forEach(function (name) {
        applyStateToContext(contexts[name], state);
      });
    }

    async function fetchCart() {
      const response = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache'
        }
      });

      if (!response.ok) {
        throw new Error('Unable to fetch /cart.js');
      }

      return response.json();
    }

    async function validate() {
      try {
        const cart = await fetchCart();
        const state = validateScudoCart(cart);
        lastState = state;
        applyStateEverywhere(state);
        return state;
      } catch (error) {
        console.error('Scudo cart validation error:', error);
        applyStateEverywhere(lastState);
        return lastState;
      }
    }

    function scheduleValidate(delay) {
      clearTimeout(validateTimer);
      validateTimer = setTimeout(function () {
        validate();
      }, typeof delay === 'number' ? delay : 150);
    }

    function startSettleValidation() {
      clearTimeout(settleTimer);
      clearInterval(settleInterval);

      let previousState = null;
      let stableCount = 0;
      let attempts = 0;
      const maxAttempts = 12;

      settleInterval = setInterval(async function () {
        attempts += 1;

        try {
          const state = await validate();

          if (statesEqual(state, previousState)) {
            stableCount += 1;
          } else {
            stableCount = 0;
          }

          previousState = state;

          if (stableCount >= 2 || attempts >= maxAttempts) {
            clearInterval(settleInterval);
            settleInterval = null;
          }
        } catch (e) {
          if (attempts >= maxAttempts) {
            clearInterval(settleInterval);
            settleInterval = null;
          }
        }
      }, 250);

      settleTimer = setTimeout(function () {
        clearInterval(settleInterval);
        settleInterval = null;
      }, 3500);
    }

    function interceptCheckoutClicks(event) {
      const trigger = event.target.closest('#checkout, #CartDrawer-Checkout');
      if (!trigger) return;

      if (!lastState.valid) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        applyStateEverywhere(lastState);
        scheduleValidate(0);
      }
    }

    function bindGlobalListeners() {
      if (booted) return;
      booted = true;

      document.addEventListener('click', interceptCheckoutClicks, true);

      document.addEventListener(
        'submit',
        function (event) {
          const form = event.target;
          if (!form) return;

          const isCartForm =
            form.id === 'cart' ||
            form.id === 'CartDrawer-Form' ||
            form.matches('form[action*="/cart"]');

          if (isCartForm && !lastState.valid) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            applyStateEverywhere(lastState);
            scheduleValidate(0);
          }
        },
        true
      );

      document.addEventListener(
        'change',
        function (event) {
          if (
            event.target.matches('input[name="updates[]"]') ||
            event.target.matches('.quantity__input')
          ) {
            scheduleValidate(150);
            startSettleValidation();
          }
        },
        true
      );

      document.addEventListener(
        'input',
        function (event) {
          if (
            event.target.matches('input[name="updates[]"]') ||
            event.target.matches('.quantity__input')
          ) {
            scheduleValidate(150);
            startSettleValidation();
          }
        },
        true
      );

      document.addEventListener(
        'click',
        function (event) {
          if (
            event.target.closest('cart-remove-button') ||
            event.target.closest('.cart-remove-button') ||
            event.target.closest('.quantity__button') ||
            event.target.closest('[name="minus"]') ||
            event.target.closest('[name="plus"]')
          ) {
            scheduleValidate(150);
            startSettleValidation();
          }
        },
        true
      );

      document.addEventListener('shopify:section:load', function () {
        scheduleValidate(80);
        startSettleValidation();
      });

      document.addEventListener('cart:refresh', function () {
        scheduleValidate(80);
        startSettleValidation();
      });

      document.addEventListener('cart:updated', function () {
        scheduleValidate(80);
        startSettleValidation();
      });

      document.addEventListener('cart-drawer:open', function () {
        scheduleValidate(80);
        startSettleValidation();
      });

      window.addEventListener('pageshow', function () {
        scheduleValidate(0);
        startSettleValidation();
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          scheduleValidate(0);
          startSettleValidation();
        });
      } else {
        scheduleValidate(0);
        startSettleValidation();
      }
    }

    function init(contextName, config) {
      contexts[contextName] = {
        rootSelector: config.rootSelector,
        messageSelector: config.messageSelector,
        checkoutSelector: config.checkoutSelector,
        dynamicCheckoutSelector: config.dynamicCheckoutSelector || ''
      };

      bindGlobalListeners();
      applyStateToContext(contexts[contextName], lastState);
      scheduleValidate(0);
      startSettleValidation();
    }

    return {
      init: init,
      validate: validate,
      scheduleValidate: scheduleValidate,
      validateScudoCart: validateScudoCart
    };
  })();
})();